module.exports = __webpack_public_path__ + "static/media/tristeza.719377f2.gif";